import React, { PropsWithChildren } from 'react';

import { Container } from './TileWidget.styled';
import { IconContainer, WidgetTitleContainer } from '../../Widgets/Widgets.styled';
import { PregnancyCalculatorState } from '../hooks/use-pregnancy-calculator';
import { CalendarHeart } from 'assets/icons/Icons';
import { Heading } from 'components/v2/Typography/Heading';
import { themes } from 'kb-shared';
import theme from 'kb-shared/theme';

interface Props {
  state: PregnancyCalculatorState;
}

export const TileWidget: React.FC<PropsWithChildren<Props>> = ({ children, state }) => {
  const DEFAULT_VARIANT = 7;
  const LMP_ENTERED_VARIANT = 11;

  const variant = state === 'lmp-entered' ? LMP_ENTERED_VARIANT : DEFAULT_VARIANT;

  return (
    <Container variant={variant} bgColor={theme.colors.semantic.lightPink}>
      <IconContainer $iconWidth={42} $iconHeight={48} $color={themes.colors.semantic.red}>
        <CalendarHeart type="solid" />
      </IconContainer>
      <WidgetTitleContainer $noMargin>
        <Heading tag="div" styledAs="h2">
          Pregnancy Calculator
        </Heading>
      </WidgetTitleContainer>
      {children}
    </Container>
  );
};
